module.exports = __webpack_public_path__ + "img/广联改版.718d62a6.png";